export const BASICUNIT = 'BasicUnit';
export const BASICUNIT_ADD = 'BasicUnit_add';
export const BASICUNIT_DELETE = 'BasicUnit_deleted';
export const BASICUNIT_EDIT = 'BasicUnit_edit';

export const BASICUNIT_SETROWDATA = 'BasicUnit_set_rowdata';
export const MODEL_OPEN = 'BasicUnit_model_open';
export const MODEL_CLOSE = 'BasicUnit_model_close';

export const BASICUNIT_LIST_SUCCESSFUL = 'BasicUnit_list_successfull';
export const BASICUNIT_ADD_SUCCESSFUL = 'BasicUnit_add_successfull';
export const BASICUNIT_EDIT_SUCCESSFUL = 'BasicUnit_edit_successfull';

export const API_ERROR = 'api_failed';
